"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFillPatternDiff = exports.getNumberFillPattern = void 0;
const bignumber_js_1 = require("bignumber.js");
/**
 * Returns a generator function to continue numbers patterns, otherwise returns null if there is no pattern.
 * @example
 * const genFn = getNumberFillPattern([1, 2, 3])
 * genFn().next().value \\ 4
 * genFn().next().value \\ 5
 * // ...
 * @example
 * // genFn will be null
 * const genFn = getNumberFillPattern([1, 3, 10])
 */
const getNumberFillPattern = (values, reverse) => {
    const processedValues = reverse ? [...values].reverse() : values;
    const diff = getFillPatternDiff(processedValues);
    if (diff === null) {
        return null;
    }
    const lastElm = processedValues[processedValues.length - 1];
    if (lastElm === null) {
        return null;
    }
    return function* () {
        let next = new bignumber_js_1.BigNumber(lastElm);
        while (true) {
            next = next.plus(diff);
            yield next.toNumber();
        }
    };
};
exports.getNumberFillPattern = getNumberFillPattern;
/**
 * Finds a pattern for array of numbers and returns the difference
 * to continue the pattern, otherwise returns null if there is no pattern.
 */
function getFillPatternDiff(array) {
    var _a, _b, _c, _d, _e, _f;
    // If the array has less than 2 elements, return null
    if (array.length < 2) {
        return null;
    }
    // Calculate the initial difference between the first two numbers
    const initialDifference = new bignumber_js_1.BigNumber((_a = array[0]) !== null && _a !== void 0 ? _a : "")
        .minus(new bignumber_js_1.BigNumber((_b = array[1]) !== null && _b !== void 0 ? _b : ""))
        .abs();
    // if the numbers are decreasing, the final number must be negative
    const sign = new bignumber_js_1.BigNumber((_c = array[0]) !== null && _c !== void 0 ? _c : "").isGreaterThan((_d = array[1]) !== null && _d !== void 0 ? _d : "")
        ? -1
        : 1;
    // Iterate through the remaining numbers in the array
    for (let i = 1; i < array.length - 1; i++) {
        // Calculate the difference between the current number and the next number
        const difference = new bignumber_js_1.BigNumber((_e = array[i]) !== null && _e !== void 0 ? _e : "")
            .minus(new bignumber_js_1.BigNumber((_f = array[i + 1]) !== null && _f !== void 0 ? _f : ""))
            .abs();
        // If the difference is not equal to the initial difference, return null
        if (!difference.isEqualTo(initialDifference)) {
            return null;
        }
    }
    // All differences are equal, so return true
    return initialDifference.multipliedBy(sign);
}
exports.getFillPatternDiff = getFillPatternDiff;
